import { To } from 'react-router';

import i18next from 'i18next';
import { atomFamily, atomWithReset } from 'jotai/utils';

import { TranslationKey } from '@/i18n';

export interface HeaderBackNavigation {
  label: string;
  to: To;
}

export interface HeaderState {
  title: string;
  backNavigation?: HeaderBackNavigation;
}

export type HeaderStateKey = 'explore';

export const headerStateFamily = atomFamily((key: HeaderStateKey) =>
  atomWithReset<HeaderState>({
    title: i18next.t(DEFAULT_TITLE_MAP[key]),
  }),
);

const DEFAULT_TITLE_MAP: Record<HeaderStateKey, TranslationKey> = {
  explore: 'Generic.explore',
};
